import { Phone, Mail, Instagram } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useState, useEffect, useRef } from "react";
export default function ContactosDeEmergencia() {
  const [visibleItems, setVisibleItems] = useState<boolean[]>([false, false, false, false, false]);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  useEffect(() => {
    const observers = itemRefs.current.map((ref, index) => {
      if (!ref) return null;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setVisibleItems(prev => {
              const newVisible = [...prev];
              newVisible[index] = true;
              return newVisible;
            });
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.2
      });
      observer.observe(ref);
      return observer;
    });
    return () => {
      observers.forEach(observer => observer?.disconnect());
    };
  }, []);
  const contacts = [{
    icon: Phone,
    title: "Lucía",
    detail: "627 03 80 65",
    link: "tel:627038065"
  }, {
    icon: Phone,
    title: "Kike",
    detail: "637 27 16 72",
    link: "tel:637271672"
  }, {
    icon: Mail,
    title: "Contacto por email",
    detail: "luciaykike2026@gmail.com",
    link: "mailto:luciaykike2026@gmail.com"
  }, {
    icon: Instagram,
    title: "Instagram",
    detail: "@luchiinda",
    link: "https://www.instagram.com/luchiinda/"
  }, {
    icon: Instagram,
    title: "Instagram",
    detail: "@kike_tgaldo",
    link: "https://www.instagram.com/kike_tgaldo/"
  }];
  const renderContactCard = (contact: any, index: number, widthClass: string) => {
    const Icon = contact.icon;
    return <div key={index} ref={el => itemRefs.current[index] = el} className={`transition-all duration-500 ${visibleItems[index] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${widthClass}`} style={{
      transitionDelay: visibleItems[index] ? `${index * 150}ms` : "0ms"
    }}>
        <a href={contact.link} target="_blank" rel="noopener noreferrer">
          <Card className="bg-transparent shadow-none hover:shadow-lg hover:-translate-y-1 transition-all duration-500 cursor-pointer group w-full">
            <CardContent className="flex flex-col items-center text-center gap-4 p-6 md:p-8">

              <div className="text-white transition-transform duration-300 group-hover:scale-110">
                <Icon className="w-7 h-7 md:w-8 md:h-8 drop-shadow-md" />
              </div>

              <div>
                <h3 className="text-2xl md:text-[2.25rem] font-display font-semibold text-white drop-shadow-md mb-1">
                  {contact.title}
                </h3>

                <p className="text-lg md:text-xl text-white drop-shadow-md break-words">
                  {contact.detail}
                </p>
              </div>

            </CardContent>
          </Card>
        </a>
      </div>;
  };
  return <section id="contactos-de-emergencia" className="relative bg-[url(https://ideal-ray.10web.cloud/wp-content/uploads/2026/02/IMG-20260210-WA0014.jpg)] bg-cover bg-center bg-no-repeat py-16 px-4">
      <div className="relative z-10 container mx-auto max-w-4xl">

        {/* Teléfonos */}
        <h2 className="text-[2rem] md:text-[2.125rem] font-display font-semibold text-center mb-8 text-white drop-shadow-lg">
          Teléfonos móviles
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {contacts.slice(0, 2).map((contact, i) => renderContactCard(contact, i, "w-full"))}
        </div>

        {/* Instagram */}
        <h2 className="text-[2rem] md:text-[2.125rem] font-display font-semibold text-center mb-8 text-white drop-shadow-lg">
          Redes sociales
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {contacts.slice(3, 5).map((contact, i) => renderContactCard(contact, i + 3, "w-full"))}
        </div>

        {/* Email centrado */}
        <div className="flex justify-center">
          <div className="w-full md:w-1/2">
            {renderContactCard(contacts[2], 2, "w-full")}
          </div>
        </div>

      </div>
    </section>;
}